export const checkIsPreorder = (preorderUntilDate?: string): boolean => {
  if (preorderUntilDate) {
    return new Date(preorderUntilDate).getTime() >= new Date().getTime()
  }
  return false
}
